import { ApplicationState } from '../store';

export const getIsModalOpen = (state: ApplicationState) => state.modal.isOpen;

export const getModalTitle = (state: ApplicationState) =>
  state.modal.content.title;
export const getModalDescription = (state: ApplicationState) =>
  state.modal.content.description;
export const getModalButtonText = (state: ApplicationState) =>
  state.modal.content.buttonText;
export const getModalOnConfirm = (state: ApplicationState) =>
  state.modal.content.onConfirm;
